<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    custom-class="opera-field-type-data-window"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <template v-if="type.category === 'TEXT' || type.category === 'NUMBER' || type.category === 'IMAGE'">
        <el-form-item v-if="type.category === 'NUMBER' || type.category === 'TEXT'" label="字段值" prop="value" required>
          <el-input v-model="form.value" placeholder="请输入字段值" v-trim/>
        </el-form-item>
        <el-form-item v-else-if="type.category === 'IMAGE'" label="上传图片" prop="value" required>
          <el-upload
            action="/api/upload/image"
            :show-file-list="false"
            :drag="true"
            accept=".png,.jpeg,.jpg,.gif"
            :with-credentials="true"
            :on-success="uploadSuccess"
          >
            <p v-if="form.value == null || form.value === ''">拖拽图片文件到此或点击选择</p>
            <img v-else :src="form.value">
          </el-upload>
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item v-for="field in fields" :label="field.label" :prop="field.variable">
          <el-input v-if="field.type === 'TEXT' || field.type === 'NUMBER'" v-model="form[field.variable]" :placeholder="`请输入${field.label}`" v-trim/>
          <el-upload
            v-if="field.type === 'IMAGE'"
            action="/api/upload/image"
            :show-file-list="false"
            :drag="true"
            accept=".png,.jpeg,.jpg,.gif"
            :with-credentials="true"
            :on-success="getFieldUploadSuccessHandler(field)"
          >
            <p v-if="form[field.variable] == null || form[field.variable] === ''">拖拽图片文件到此或点击选择</p>
            <img v-else :src="form[field.variable]">
          </el-upload>
        </el-form-item>
      </template>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaTemplateFieldTypeDataListWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  props: {
    type: {
      required: true
    }
  },
  data () {
    const _this = this
    return {
      // 表单数据
      form: {
        id: null
      },
      // 验证规则
      rules: {
        value: [
          { validator: _this.checkRequired }
        ]
      }
    }
  },
  computed: {
    fields () {
      if (this.type.category === 'OBJECT') {
        try {
          return JSON.parse(this.type.fieldConfig)
        } catch (e) {
          console.error('字段配置错误，配置值：' + this.type.fieldConfig)
        }
      }
      return []
    }
  },
  methods: {
    /**
     * 打开窗口
     */
    open (title, target) {
      this.title = title
      this.visible = true
      // 构建动态form
      this.form = { id: null }
      if (this.type.category === 'OBJECT') {
        for (const field of this.fields) {
          this.$set(this.form, field.variable, '')
        }
      } else {
        this.$set(this.form, 'value', '')
      }

      // 编辑
      if (target != null) {
        this.$nextTick(() => {
          for (const key in this.form) {
            this.form[key] = target[key]
          }
        })
      }
    },
    // checkRequired
    checkRequired (rule, value, callback) {
      if (value.trim() === '') {
        if (this.type.category === 'IMAGE') {
          callback(new Error('请上传图片'))
          return
        }
        callback(new Error('请输入字段值'))
        return
      }
      callback()
    },
    // 上传成功
    uploadSuccess (response) {
      if (!response.success) {
        this.$tip.error(response)
        return
      }
      this.form.value = response.data.accessUri
    },
    // 获取字段值上传成功处理函数
    getFieldUploadSuccessHandler (field) {
      return (response) => {
        if (!response.success) {
          this.$tip.error(response)
          return
        }
        this.form[field.variable] = response.data.accessUri
      }
    },
    /**
     * 确认（点击确认按钮后触发）
     */
    confirm () {
      let value = this.form.value
      if (this.fields.length > 0) {
        value = {}
        for (const field of this.fields) {
          value[field.variable] = this.form[field.variable]
        }
        value = JSON.stringify(value)
      }
      this.form = {
        id: this.form.id,
        typeId: this.type.id,
        value
      }
      if (this.form[this.configData['field.id']] == null || this.form[this.configData['field.id']] === '') {
        this.__confirmCreate()
        return
      }
      this.__confirmEdit()
    }
  },
  created () {
    this.config({
      api: '/template/fieldTypeData',
      'field.id': 'id'
    })
  }
}
</script>

<style lang="scss">
.opera-field-type-data-window {
  .el-upload {
    width: 100%;
  }
  .el-upload-dragger {
    width: 100%;
    height: 250px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
</style>
